/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TradeImportLogDto
 */
export interface TradeImportLogDto {
    /**
     * 
     * @type {string}
     * @memberof TradeImportLogDto
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof TradeImportLogDto
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof TradeImportLogDto
     */
    tradesCount: number;
    /**
     * 
     * @type {boolean}
     * @memberof TradeImportLogDto
     */
    reverted: boolean;
    /**
     * 
     * @type {string}
     * @memberof TradeImportLogDto
     */
    importerName: string;
    /**
     * 
     * @type {string}
     * @memberof TradeImportLogDto
     */
    portfolioId: string;
}

export function TradeImportLogDtoFromJSON(json: any): TradeImportLogDto {
    return TradeImportLogDtoFromJSONTyped(json, false);
}

export function TradeImportLogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TradeImportLogDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'date': (new Date(json['date'])),
        'tradesCount': json['tradesCount'],
        'reverted': json['reverted'],
        'importerName': json['importerName'],
        'portfolioId': json['portfolioId'],
    };
}

export function TradeImportLogDtoToJSON(value?: TradeImportLogDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'date': (value.date.toISOString()),
        'tradesCount': value.tradesCount,
        'reverted': value.reverted,
        'importerName': value.importerName,
        'portfolioId': value.portfolioId,
    };
}

